import React, { useEffect, useCallback, useState} from 'react';
import Settings from 'components/preferences/Settings.js';
import { Button } from 'reactstrap';
import {setShowSettings} from 'actions/index.js';
import Modal from 'react-bootstrap/Modal';
import {connect} from 'react-redux';

const SettingsModal = (props) => { 
    const onClickCancel = useCallback(() => {
        props.setShowSettings(false);
        if (props.hide) {
            props.hide();
        }
    }, []);

    return (
        <Modal dialogClassName="preset-modal" show={true} onHide={onClickCancel}>
          <Modal.Header closeButton>
            <Modal.Title>Settings</Modal.Title>
          </Modal.Header >
          <Modal.Body>
            <Settings onlyAppearance={props.onlyAppearance} sequencerEngine={props.sequencerEngine}/>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={onClickCancel}>
              Done
            </Button>
          </Modal.Footer>
        </Modal>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setShowSettings: show => dispatch(setShowSettings(show)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingsModal);
